import { Fragment, React, useEffect, useState } from "react";
import { GridToolbar } from "@mui/x-data-grid-pro";

import PrimaryDataTable from "../../../../components/PrimaryDataTable";
import { listOfApprovedColumns } from "../../Approver/const";
import defaultOptions from "../../../../utils/defaultOptions";

const Approved = ({ data, loading }) => {
  const [pageSize, setPageSize] = useState(defaultOptions.pageSize);
  const columns = listOfApprovedColumns();

  return (
    <Fragment>
      <PrimaryDataTable
        rows={data}
        columns={columns}
        disableColumnSelector={true}
        getRowId={(row) => row.detail_id}
        pageSize={pageSize}
        onPageSizeChange={setPageSize}
        rowsPerPageOptions={defaultOptions.rowsPerPageOptions}
        hideFooterSelectedRowCount
        components={{
          Toolbar: GridToolbar,
        }}
        loading={loading}
      />
    </Fragment>
  );
};

export default Approved;
